import "./css/recharge.css";

import { initRecharge } from "@rechargeapps/storefront-client";
import VbcSelection from "./js/recharge/VbcSelection";
import VbcAddons from "./js/recharge/VbcAddons";
import VbcManageSubscriptionCta from "./js/recharge/VbcManageSubscriptionCta";
import {
  loadSlotExtensions,
  unloadSlotExtensions,
} from "./js/recharge/extensions";

initRecharge();

customElements.define("vbc-selection", VbcSelection);
customElements.define("vbc-addons", VbcAddons);
customElements.define("vbc-manage-subscription-cta", VbcManageSubscriptionCta);

/**
 * Change Recharge "Return to login" URL on customer portal page
 * shown to users who don't have a subscription. Redirect back to
 * account page (/account) rather than login
 */
const returnLink = document.querySelector(
  ".recharge.page__customers__request-invite [href='/account/login']",
);
if (returnLink && window.routes.account_url) {
  returnLink.setAttribute("href", window.routes.account_url);
}

document.addEventListener("Recharge::slot::mounted", async (event) => {
  await loadSlotExtensions(event.detail);
});

document.addEventListener("Recharge::slot::unmounted", (event) => {
  unloadSlotExtensions(event.detail);
});

document.addEventListener("Recharge::click::manageSubscription", (event) => {
  const {
    analytics: { pathname },
    payload: { subscriptionId },
  } = event.detail;

  if (pathname === "/overview" && subscriptionId) {
    event.preventDefault();

    const reroute = new URL(window.location);

    reroute.pathname = reroute.pathname.replace(
      "/overview",
      `/subscriptions/${subscriptionId}`,
    );

    // go to subscription detail page rather than opening modal
    // (since we can't show custom content in the modal)
    window.location.assign(reroute);
  }
});
